import React from 'react'

function AdminsCard() {
  return (
    <div>
    <div>
    <p className="text-gray-500">Total: {17}</p>
      <div className="p-3 flex flex-row justify-between items-center ">
      <div className="">
        <p>Online</p>
        <div className="bg-gray-50 border-b-4 border-b-lime-500 px-4 py-3 rounded-sm  text-2xl">
          <p className="text-gray-500">{4}</p>
        </div>
      </div>
      <div >
        <p>Away</p>
        <div className="bg-gray-50 border-b-4 border-b-orange-500 px-4 py-3 rounded-sm  text-2xl">
          <p className="text-gray-500">{3}</p>
        </div>
      </div>
      <div >
        <p>Offline</p>
        <div className="bg-gray-50 border-b-4 border-b-red-500 px-4 py-3 rounded-sm  text-2xl">
          <p className="text-gray-500">{10}</p>
        </div>
      </div>
      </div>
    </div>
  </div>
  )
}

export default AdminsCard